import React, { useEffect, useRef, useState } from 'react';
import { Grid, Box, CircularProgress } from '@mui/material';
import NoResult from '../../assets/images/no-result.png';
import Strings from '../../constants/stringConstant';
import leadDashboardStyles from '../../pages/LeadManagementPage/LeadDashboard/leadDashboard.module.css';
import Tabs from '../Tab/tabs';
import Breadcrumb from '../BreadCrumb/breadCrumb';
import SearchBox from '../SearchBox/searchBox';
import CombinedFilter from '../Filter/combinedFilter';
import PropTypes from 'prop-types';
import PaginationComp from '../Pagination/paginationComp';
import { useDispatch, useSelector } from 'react-redux';
import { setLocValue } from '../../state/slice/locationSlice';
import { getUserData } from '../../utils/appUtils';
import ButtonComp from '../Button/buttonComp';
import makeApiCall from '../../api/makeApiCall';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import {
  downloadDisbursementApi,
  orderConfirmationBulkUploadApi,
  orderConfirmationDownloadApi,
  uploadDisbursementApi,
} from '../../api/request/disbursementApi/disbursementApi';
import { resetAllEligibilityCheck } from '../../state/slice/EligibilitySlice';
import PartialUploadModal from '../../pages/Masters/StateMasters/partialUploadModal';
import SuccessModal from '../Modal/successModal';

const DashboardComponent = ({
  paths,
  fetchData,
  CardComponent,
  buttonOnclick,
  searchQuery,
  currentPage,
  selectedTab,
  handlePageChange,
  totalPages,
  totalCount,
  cards = [],
  loading,
  tabs,
  onSearch,
  modalComponent,
  handleTabClick,
  refreshTrue,
  setRejectModal,
  dashboardType,
  buttonName,
  countValue,
  filter,
}) => {
  const dispatch = useDispatch();
  const { t: translator } = useTranslation();
  const fileInputRef = useRef(null);
  const [partialUpload, setPartialUpload] = useState(false);
  const [uploadSuccessModal, setUploadSuccessModal] = useState(false);
  const [uploadFailedModal, setUploadFailedModal] = useState(false);
  const [failedRecords, setFailedRecords] = useState([]);
  const [totalRecordCount, setTotalRecordCount] = useState('');
  const { productCategories } = useSelector(state => state.productFilterSlice);
  useEffect(() => {
    if (dashboardType) {
      fetchData();
    }
  }, [searchQuery, selectedTab, refreshTrue]);
  useEffect(() => {
    if (
      dashboardType === Strings.loan_applications.dashboard_type_eligiblity ||
      dashboardType === Strings.loan_applications.dashboard_type_onhold
    ) {
      dispatch(resetAllEligibilityCheck());
    }
    if (
      dashboardType === Strings.leadManagement.lead_type &&
      dashboardType === Strings.mcc_dashboard.mcc_type &&
      dashboardType === Strings.platform_management.platform_type
    ) {
      window.history.pushState(null, null, window.location.href);
      const userData = getUserData();
      dispatch(
        setLocValue({
          locValue: Strings.locValue.login_loc,
          userId: userData?.userId,
        }),
      );
      const handleBackButton = event => {
        event.preventDefault(); // Prevents the default back navigation
        window.history.pushState(null, null, window.location.href); // Keeps user on the same page
      };

      window.addEventListener('popstate', handleBackButton);

      return () => {
        window.removeEventListener('popstate', handleBackButton);
      };
    }
  }, [dashboardType]);
  useEffect(() => {
    if (uploadSuccessModal) {
      setTimeout(() => {
        setUploadSuccessModal(false);
      }, 2000);
    }
  }, [uploadSuccessModal]);
  useEffect(() => {
    if (uploadFailedModal) {
      setTimeout(() => {
        setUploadFailedModal(false);
      }, 2000);
    }
  }, [uploadFailedModal]);
  const handleDocumentUpload = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = event => {
    const file = event.target.files[0];
    if (
      file.type !==
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ) {
      toast.error('Only XLSX files are allowed.');
      fileInputRef.current.value = '';

      return;
    }
    UploadDocumentData(file);
  };
  const UploadDocumentData = async file => {
    try {
      let response;
      if (
        dashboardType === Strings.loan_applications.application_type_order_con
      ) {
        const formData = new FormData();
        formData.append('excelFile', file);
        response = await makeApiCall(orderConfirmationBulkUploadApi(formData));
      } else {
        const formData = new FormData();
        formData.append('csvFile', file);
        formData.append(
          'productCategoryId',
          productCategories || 'Surabhi-DCL-Unsecured',
        );
        if (productCategories === Strings.loan_applications.securedBusinessLoan) {
          formData.append('trancheNumber', 1);
        }

        response = await makeApiCall(uploadDisbursementApi(formData));
      }
      if (response?.data?.status === Strings.success) {
        await new Promise(resolve => setTimeout(resolve, 1200));
        fetchData();
        const message = response?.data?.data?.message;
        const totalRecordCounts = response?.data?.data?.totalRecordCount || 0;
        setTotalRecordCount(totalRecordCounts);
        if (message === 'Partial Upload Done') {
          setFailedRecords(response?.data?.data?.failedRows || []);
          setPartialUpload(true);
        } else {
          setUploadSuccessModal(true);
        }
      } else {
        let errorCode = response?.data?.error?.errorCode;
        let errorMessage = response?.data?.error?.errorMessage;

        if (!errorCode || errorMessage === `ErrorMessages.${errorCode}`) {
          errorCode = 'SAMASTA001';
          errorMessage = translator('ErrorMessages.SAMASTA001');
        }
        if (response?.data?.error?.errorCode !== 'SAMASTA015') {
          toast.error(errorMessage);
        }
        setUploadFailedModal(true);
        fileInputRef.current.value = '';
      }
    } catch (error) {
      // toast.error(Strings.apiError, {
      //   position: 'top-right',
      // });
      setUploadFailedModal(true);
      fileInputRef.current.value = '';
    }
  };
  const downloadBase64CSV = (base64Data, fileName = 'data.xlsx') => {
    // Convert Base64 to a Blob
    const byteCharacters = atob(base64Data); // Decode Base64
    const byteNumbers = new Uint8Array(byteCharacters.length);

    for (let val = 0; val < byteCharacters.length; val++) {
      byteNumbers[val] = byteCharacters.charCodeAt(val);
    }

    const blob = new Blob([byteNumbers], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    // Create a temporary download link
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;

    // Append to DOM and trigger download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const handleDownload = async () => {
    try {
      if (
        dashboardType === Strings.loan_applications.application_type_order_con
      ) {
        const response = await makeApiCall(orderConfirmationDownloadApi());
        if (response?.data?.status === Strings.success) {
          const responseValue = response?.data?.data;
          downloadBase64CSV(responseValue?.data, 'doc.xlsx');
          fetchData();
        } else if (
          response?.data?.error?.errorCode ===
          translator('ErrorCodes.SAMASTA015')
        ) {
          toast.warning('No document found');
        } else {
          toast.error(translator('ErrorMessages.' + 'SAMASTA001'), {
            position: 'top-right',
          });
        }
      } else {
        const response = await makeApiCall(
          downloadDisbursementApi({
            productCategoryId: productCategories || 'Surabhi-DCL-Unsecured',
          }),
        );
        if (response?.data?.status === Strings.success) {
          const responseValue = response?.data?.data;
          window.open(responseValue, '_blank', 'noopener,noreferrer');
          fetchData();
        } else if (
          response?.data?.error?.errorCode ===
          translator('ErrorCodes.SAMASTA015')
        ) {
          toast.warning('No document found');
        } else {
          toast.error(translator('ErrorMessages.' + 'SAMASTA001'), {
            position: 'top-right',
          });
        }
      }
    } catch (error) {
      console.log(
        'An error occurred at Download Document Execution-component',
        error,
      );
      toast.error(translator('ErrorMessages.' + 'SAMASTA001'), {
        position: 'top-right',
      });
    }
  };

  return (
    <Box className={leadDashboardStyles.dashboard_container}>
      <Breadcrumb
        paths={paths}
        buttonOnclick={buttonOnclick}
        buttonName={buttonName}
      />
      <Box className={leadDashboardStyles.dashboard_sub_container}>
        <Grid
          container
          className={leadDashboardStyles.dashboard_search_container}>
          <Grid item>
            <SearchBox searchQuery={searchQuery} onSearch={onSearch} />
          </Grid>
          {dashboardType ===
            Strings.manageReassignement.manageReassignementHeader ? (
            filter
          ) : (
            <Grid item>
              <CombinedFilter
                fetchData={fetchData}
                dashboardType={dashboardType}
              />
            </Grid>
          )}
        </Grid>
        {tabs && (
          <Box sx={{ paddingTop: '12px', paddingBottom: '24px' }}>
            <Tabs
              tabs={tabs}
              selectedTab={selectedTab}
              handleTabClick={handleTabClick}
            />
          </Box>
        )}
        {cards.length > 0 && (
          <Grid container sx={{ justifyContent: 'space-between', gap: 2 }}>
            <Box
              className="text-medium-16px"
              sx={{
                paddingTop:
                  dashboardType == Strings.mcc_dashboard.mcc_type ||
                    dashboardType == Strings.platform_management.platform_type ||
                    dashboardType ==
                    Strings.loan_applications.dashBoard_type_rejected ||
                    dashboardType ==
                    Strings.loan_applications.dashboard_type_onhold ||
                    dashboardType ==
                    Strings.loan_applications.dashboard_type_part_approval ||
                    dashboardType ==
                    Strings.loan_applications.dashboard_type_con ||
                    dashboardType ==
                    Strings.manageReassignement.manageReassignementHeader ||
                    dashboardType ==
                    Strings.loan_applications.dashboard_type_order_con
                    ? '24px'
                    : '0px',
              }}>
              {`${totalCount} ${countValue}`}
            </Box>

            {(((dashboardType === 'Disbursement' || dashboardType === Strings.loan_applications.app_type_tranche_dis) &&
              selectedTab === 'Pending for Fund Transfer') ||
              dashboardType === 'Order Confirmation') && (
                <Box>
                  <Grid
                    container
                    sx={{
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      gap: 2,
                      marginTop:
                        dashboardType === 'Order Confirmation' ? '16px' : '0px',
                    }}>
                    {' '}
                    <ButtonComp
                      className="text-bold-14px"
                      value={'Download'}
                      gradient="linear-gradient(168deg, #F37021 -13.5%, #FDBA12 119.9%)"
                      height="36px"
                      width="160px"
                      padding="14px 24px"
                      textcolor="#ffff"
                      borderRadius="8px"
                      onClick={handleDownload}
                    />
                    <ButtonComp
                      variant="outlined"
                      className="text-bold-14px"
                      value="Upload"
                      height="36px"
                      width="160px"
                      padding="14px 24px"
                      textcolor="#F37021"
                      borderRadius="8px"
                      border="1px solid #F37021"
                      onClick={handleDocumentUpload}
                    />
                    {
                      <input
                        type="file"
                        accept=".xlsx"
                        onChange={handleFileChange}
                        ref={fileInputRef}
                        style={{ display: 'none' }}
                      />
                    }
                  </Grid>
                </Box>
              )}
          </Grid>
        )}
        {loading ? (
          <Box className={leadDashboardStyles.dashboard_loader}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            {cards.length > 0 ? (
              <Grid
                container
                spacing={1.5}
                className={leadDashboardStyles.dashboard_card_container}>
                {cards.map((card, index) => (
                  <Grid item xs={12} md={6} lg={4} key={index}>
                    <CardComponent
                      cardData={card}
                      setRejectModal={setRejectModal}
                      dashboardType={dashboardType}
                      fetchData={fetchData}
                    />
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Grid
                container
                sx={{
                  flexDirection: 'column',
                  alignItems: 'center',
                  height: '100%',
                  justifyContent: 'center',
                }}>
                <img
                  src={NoResult}
                  alt="no result"
                  style={{ width: '250px', height: '250px' }}
                />
                <Box
                  className="text-medium-18px"
                  sx={{ color: '#322E56', paddingTop: '12px' }}>
                  {Strings.leadManagement.noRecord}
                </Box>
                <Box
                  className="text-400-14px "
                  sx={{ color: '#7D778C', paddingTop: '8px' }}>
                  {Strings.leadManagement.nothingHere}
                </Box>
              </Grid>
            )}
          </>
        )}

        {loading ||
          (totalPages > 0 && (
            <PaginationComp
              totalPages={totalPages}
              currentPage={currentPage}
              handlePageChange={handlePageChange}
            />
          ))}
        {modalComponent}
        <SuccessModal
          open={uploadSuccessModal}
          onClose={() => setUploadSuccessModal(false)}
          message={Strings.masters.bulk_upload_success}
          subMessage={`All ${totalRecordCount} records have been successfully uploaded.`}
        />
        <SuccessModal
          open={uploadFailedModal}
          onClose={() => setUploadFailedModal(false)}
          message={Strings.masters.bulk_upload_failed}
          subMessage={Strings.masters.bulk_upload_failed_des}
          reject
        />
        {partialUpload && (
          <PartialUploadModal
            isOpen={partialUpload}
            onClose={() => setPartialUpload(false)}
            failedRecords={failedRecords}
            totalRecordCount={totalRecordCount}
          />
        )}
      </Box>
    </Box>
  );
};
DashboardComponent.propTypes = {
  paths: PropTypes.any,
  fetchData: PropTypes.any,
  CardComponent: PropTypes.any,
  buttonOnclick: PropTypes.any,
  searchQuery: PropTypes.string,
  currentPage: PropTypes.number,
  selectedTab: PropTypes.string,
  handlePageChange: PropTypes.any,
  totalPages: PropTypes.number,
  totalCount: PropTypes.any,
  cards: PropTypes.any,
  loading: PropTypes.bool,
  tabs: PropTypes.any,
  onSearch: PropTypes.any,
  modalComponent: PropTypes.any,
  handleTabClick: PropTypes.any,
  refreshTrue: PropTypes.any,
  setRejectModal: PropTypes.any,
  dashboardType: PropTypes.string,
  buttonName: PropTypes.string,
  countValue: PropTypes.string,
  filter: PropTypes.any,
};
export default DashboardComponent;
